import { IDataHandler } from '../IDataHandler';
import { DataRestoreEventName } from '../TrackingEvent';
import { DataRestoreDataSet } from '../DataSet/DataRestore';

const DataRestoreDataMap: {
    [key in DataRestoreEventName]: (keyof DataRestoreDataSet)[];
} = {
    [DataRestoreEventName.dataRestore]: [
        'restoreSelection',
        'playerDataSelection',
        'dataConflictAutoResolved',
        'dataConflictAutoResolveReason',
    ],
};

export class DataRestoreDataHandler implements IDataHandler<DataRestoreDataSet> {
    public data = new DataRestoreDataSet();

    public getEventData(eventName: DataRestoreEventName): DataRestoreDataSet {
        const result = {} as DataRestoreDataSet;
        DataRestoreDataMap[eventName].forEach(key => {
            // @ts-ignore
            result[key] = this.data[key];
        });

        // Reset data.
        if (eventName === DataRestoreEventName.dataRestore) {
            this.clearData();
        }

        return result;
    }

    public clearData(): void {
        this.data = new DataRestoreDataSet();
    }
}
